import { useQuery } from '@tanstack/react-query';

export function useSocialLinks() {
  const { data } = useQuery({
    queryKey: ['socialLinks'],
    queryFn: async () => {
      const res = await fetch('/api/social-links');
      const d = await res.json();
      return d.exito ? d.datos : {};
    },
    staleTime: 10 * 60 * 1000,
  });

  return data || {};
}
